import { formatINR } from "../../lib/api";
import { Landmark, TrendingDown } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend, CartesianGrid } from "recharts";

const CAT_COLORS = {
  Fuel: "#C84B31", Toll: "#E4A11B", Maintenance: "#3A7CA5", Salary: "#5C7457",
  Office: "#8A5A83", Misc: "#A09E96",
};

function monthLabel(m) {
  const [y, mo] = (m || "").split("-");
  if (!y) return m;
  const names = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return `${names[parseInt(mo, 10) - 1] || mo} ${y.slice(2)}`;
}

export function AccountBalancesCards({ balances = [] }) {
  if (!balances.length) return null;
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 mb-4" data-testid="account-balances">
      {balances.map((b) => (
        <div key={b.account_label} className="border border-[#E5E3DB] bg-white p-4 rounded" data-testid={`balance-card-${b.bank_account_id || b.account_label}`}>
          <div className="flex items-center gap-1.5 text-xs text-[#68665E] font-medium truncate">
            <Landmark className="w-3.5 h-3.5 text-[#C84B31] shrink-0" />
            <span className="truncate" title={b.account_label}>{b.account_label}</span>
          </div>
          <div className="text-2xl font-bold text-[#1A1A18] mt-1.5 font-headings" data-testid="balance-amount">{formatINR(b.balance)}</div>
          <div className="text-[11px] text-[#A09E96] mt-0.5">as of {b.as_of ? b.as_of.split("-").reverse().join("/") : "—"}</div>
        </div>
      ))}
    </div>
  );
}

export function MonthlySpendChart({ data }) {
  const series = data?.series || [];
  const categories = data?.categories || [];
  if (!series.length) return null;
  return (
    <div className="border border-[#E5E3DB] bg-white p-4 mb-4 rounded" data-testid="monthly-spend-chart">
      <div className="flex items-center gap-2 mb-3">
        <TrendingDown className="w-4 h-4 text-[#C84B31]" />
        <div className="section-title mb-0">Monthly Spend by Category</div>
      </div>
      <div style={{ width: "100%", height: 260 }}>
        <ResponsiveContainer>
          <BarChart data={series} margin={{ top: 8, right: 12, left: 4, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#EFEDE6" vertical={false} />
            <XAxis dataKey="month" tickFormatter={monthLabel} tick={{ fontSize: 12, fill: "#68665E" }} />
            <YAxis tickFormatter={(v) => (v >= 100000 ? `${(v / 100000).toFixed(1)}L` : v >= 1000 ? `${(v / 1000).toFixed(0)}k` : v)} tick={{ fontSize: 12, fill: "#68665E" }} width={44} />
            <Tooltip formatter={(v, n) => [formatINR(v), n]} labelFormatter={monthLabel} contentStyle={{ fontSize: 12, borderColor: "#E5E3DB" }} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            {categories.map((c) => (
              <Bar key={c} dataKey={c} stackId="spend" fill={CAT_COLORS[c] || "#A09E96"} radius={[0, 0, 0, 0]} />
            ))}
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
